var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor_contenido"},[_c('div',{staticClass:"cabecera_contenido"}),_c('div',{staticClass:"contenido_"},[_c('Registro')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }